import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'cancel-withdrawal',
        (state.get('cancel-withdrawal') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, action) {
    return state.set(
        'cancel-withdrawal',
        (state.get('cancel-withdrawal') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(action.errors))
    );
}

export function finish(state, action) {
    return state
        .set(
            'cancel-withdrawal',
            (state.get('cancel-withdrawal') || Map())
                .set('state', 'FINISHED')
                .set('data', fromJS(action.data))
                .set('errors', void 0)
        );
}

export function clear(state) {
    return state.set('cancel-withdrawal', Map());
}
